import { useEffect, useState } from "react";
import { COBRANZA_REJECTED_POLICIES_PAGE_SIZE } from "../../../constants/cobranza.constants";
export var useRejectedPoliciesModal = function (props) {
    var _a = useState(1), page = _a[0], setPage = _a[1];
    useEffect(function () {
        setPage(1);
    }, [props.opened, props.title]);
    return {
        page: page,
        pageSize: COBRANZA_REJECTED_POLICIES_PAGE_SIZE,
        totalItems: props.rows.length,
        showPagination: props.rows.length > COBRANZA_REJECTED_POLICIES_PAGE_SIZE,
        onPageChange: setPage,
    };
};
